const u = (id, w = 1600) =>
    `https://images.unsplash.com/${id}?q=80&w=${w}&auto=format&fit=crop`;

export const IMAGES = {
    hero: u("photo-1721054939742-713e1cd8e314", 2200),
    dumpTruck: u("photo-1622645636770-11fbf0611463"),
    highwayTruck: u("photo-1670509295484-df0c2512fec4"),
    semiDriving: u("photo-1711942179703-fce59b6afac6"),
    duskTruck: u("photo-1519003722824-194d4455a60c", 2000),
    scania: u("photo-1601584115197-04ecc0da31d7"),
    volvo: u("photo-1592838064575-70ed626d3a0e"),
    warehouse: u("photo-1586528116311-ad8dd3c8310d"),
    containers: u("photo-1578575437130-527eed3abbec"),
    aerialHighway: u("photo-1494412574643-ff11b0a5c1c3", 2000),
    nightHighway: u("photo-1501700493788-fa1a4fc9fe62", 2000),
    construction: u("photo-1541888946425-d81bb19240f5"),
    blueprint: u("photo-1503387762-592deb58ef4e"),
    engineer: u("photo-1581094794329-c8112a89af12"),
    corporate: u("photo-1486406146926-c627a92ad1ab"),
    team: "https://images.pexels.com/photos/4487383/pexels-photo-4487383.jpeg?auto=compress&cs=tinysrgb&w=1600",
    refinery: u("photo-1516937941344-00b4e0337589"),
    port: u("photo-1494412651409-8963ce7935a7"),
    shelves: u("photo-1587293852726-70cdb56c2866"),
    portNight: u("photo-1590496793929-36417d3117de", 2000),
    workshop: u("photo-1615906655593-ad0386982a0f"),
};

export const CONTACT = {
    phone: "+351 936 750 002",
    phoneHref: "tel:+351936750002",
    email: "talzira71@gmail.com",
    address: "Rua Senhora dos Remédios",
    locality: "6100-699 Sertã, Portugal",
};

export const NAV_LINKS = [
    { to: "/", label: "Início" },
    { to: "/empresa", label: "Empresa" },
    { to: "/servicos", label: "Serviços" },
    { to: "/frota", label: "Frota" },
    { to: "/experiencia", label: "A Nossa Experiência" },
    { to: "/projetos", label: "Projetos" },
    { to: "/contactos", label: "Contactos" },
];

export const SERVICES = [
    {
        id: "inertes",
        title: "Transporte de Todo o Tipo de Inertes",
        short: "Transporte de britas, tout-venant, terras e outros materiais para obras.",
        long: "Asseguramos o transporte de inertes — britas, tout-venant, areias e terras — entre pedreiras, centrais e frentes de obra, com camiões basculantes e semirreboques preparados para operações intensivas e continuadas.",
        features: [
            "Britas, tout-venant, areias e terras",
            "Camiões basculantes e semirreboques",
            "Operações continuadas em obra",
            "Resposta rápida a picos de produção",
        ],
        image: IMAGES.dumpTruck,
    },
    {
        id: "betuminosos",
        title: "Transporte de Betuminosos",
        short: "Transporte de materiais betuminosos entre centrais e obras.",
        long: "Transportamos materiais betuminosos entre centrais de betão asfáltico e frentes de pavimentação, garantindo cadeia de abastecimento contínua para que a aplicação nunca pare.",
        features: [
            "Ligação central — obra sem interrupções",
            "Viaturas preparadas para massas betuminosas",
            "Coordenação com equipas de pavimentação",
            "Operações noturnas e de grande dimensão",
        ],
        image: IMAGES.nightHighway,
    },
    {
        id: "agua",
        title: "Transporte de Água",
        short: "Transporte de água através de cisternas autorizadas e equipamentos adequados.",
        long: "Dispomos de cisternas de diferentes capacidades para o transporte e abastecimento de água em obras, explorações e operações industriais, com equipamentos adequados a cada contexto.",
        extra: "Transporte e abastecimento de água potável para reservatórios, aldeias, localidades e outros pontos de consumo.",
        features: [
            "Cisternas de diferentes capacidades",
            "Abastecimento a obras e industria",
            "Equipamentos adequados e autorizados",
            "Disponibilidade para operações prolongadas",
        ],
        image: IMAGES.semiDriving,
    },
    {
        id: "equipamentos",
        title: "Transporte de Equipamentos",
        short: "Transporte de máquinas, equipamentos pesados e veículos através de porta-máquinas.",
        long: "Transportamos máquinas de obra, equipamentos pesados e veículos industriais através de porta-máquinas, com carregamento e transporte planeados ao detalhe.",
        features: [
            "Porta-máquinas de grande capacidade",
            "Máquinas de obra e equipamentos pesados",
            "Planeamento de carregamento e rota",
            "Operações em Portugal e Espanha",
        ],
        image: IMAGES.construction,
    },
    {
        id: "mercadorias",
        title: "Transporte de Mercadorias",
        short: "Soluções de transporte rodoviário para diferentes tipos de mercadoria.",
        long: "Prestamos soluções de transporte rodoviário para diferentes tipos de mercadoria, com flexibilidade de viaturas e uma equipa habituada a responder a operações exigentes.",
        features: [
            "Diferentes tipos de mercadoria",
            "Pisos móveis e graneleiros",
            "Soluções à medida de cada operação",
            "Cumprimento rigoroso de prazos",
        ],
        image: IMAGES.warehouse,
    },
    {
        id: "internacional",
        title: "Transporte Internacional",
        short: "Operações de transporte em Portugal e Espanha.",
        long: "Realizamos operações de transporte em Portugal e Espanha, com experiência consolidada em trajetos internacionais e capacidade para adaptar recursos a cada operação.",
        features: [
            "Operações regulares Portugal — Espanha",
            "Experiência em trajetos internacionais",
            "Gestão documental da operação",
            "Rede de recursos flexível",
        ],
        image: IMAGES.aerialHighway,
    },
];

export const FLEET_CATEGORIES = [
    "Todos",
    "Basculantes",
    "Cisternas",
    "Tratores",
    "Porta-Máquinas",
    "Gruas",
    "Semirreboques",
    "Outros",
];

export const FLEET = [
    {
        name: "Camião Basculante 4 Eixos",
        category: "Basculantes",
        brand: "Renault / IVECO",
        specs: ["Caixa basculante reforçada", "Tração 8x4", "Preparado para obra"],
        capacity: "≈ 25 t",
        image: IMAGES.dumpTruck,
    },
    {
        name: "Camião Basculante 3 Eixos",
        category: "Basculantes",
        brand: "Scania",
        specs: ["Caixa em alumínio", "Versátil em obra e estrada"],
        capacity: "≈ 20 t",
        image: IMAGES.hero,
    },
    {
        name: "Trator Rodoviário 4x2",
        category: "Tratores",
        brand: "Renault T",
        specs: ["Acoplável a semirreboques", "Longo curso"],
        capacity: "—",
        image: IMAGES.scania,
    },
    {
        name: "Semirreboque Basculante",
        category: "Semirreboques",
        brand: "Basculante em alumínio",
        specs: ["3 eixos", "Inertes e agregados"],
        capacity: "≈ 30 m³",
        image: IMAGES.highwayTruck,
    },
    {
        name: "Semirreboque Basculante de 2 Eixos",
        category: "Semirreboques",
        brand: "Semirreboque basculante",
        specs: ["2 eixos", "Inertes, britas e agregados"],
        capacity: "—",
        image: IMAGES.dumpTruck,
    },
    {
        name: "Semirreboque Cisterna — Água",
        category: "Cisternas",
        brand: "Cisterna em inox",
        specs: ["Compartimentada", "Abastecimento a obras"],
        capacity: "30.000 L",
        image: IMAGES.semiDriving,
    },
    {
        name: "Porta Máquinas",
        category: "Porta-Máquinas",
        brand: "Gondola rebaixada",
        specs: ["Rampas hidráulicas", "Máquinas de obra e veículos"],
        capacity: "≈ 40 t",
        image: IMAGES.construction,
    },
    {
        name: "Camiões com Grua",
        category: "Gruas",
        brand: "Grua articulada",
        specs: ["Carga e descarga autónoma", "Materiais e equipamentos"],
        capacity: "30 t/m",
        image: IMAGES.nightHighway,
    },
    {
        name: "Semirreboque Piso Móvel",
        category: "Semirreboques",
        brand: "Walking floor",
        specs: ["Descarga horizontal", "Materiais a granel"],
        capacity: "≈ 90 m³",
        image: IMAGES.containers,
    },
    {
        name: "Semirreboque Graneleiro",
        category: "Outros",
        brand: "Graneleiro basculante",
        specs: ["Cereais e granéis", "Descarga rápida"],
        capacity: "≈ 30 t",
        image: IMAGES.shelves,
    },
    {
        name: "Cisterna Rígida — Água",
        category: "Cisternas",
        brand: "Camião cisterna",
        specs: ["Distribuição local", "Barra de rega"],
        capacity: "20.000 L",
        image: IMAGES.highwayTruck,
    },
    {
        name: "Giratória Volvo EC220E",
        category: "Outros",
        brand: "Volvo CE",
        specs: [
            "Martelo hidráulico e balde",
            "Escavação, abertura de valas e movimentação de terras",
            "Preparação de terrenos e apoio a obras de construção e infraestruturas",
        ],
        capacity: "—",
        image: IMAGES.construction,
    },
];

export const PROJECT_AREAS = [
    {
        title: "Obras Rodoviárias",
        desc: "Abastecimento continuado de materiais a frentes de obra rodoviária.",
        image: IMAGES.aerialHighway,
    },
    {
        title: "Pavimentação",
        desc: "Transporte de betuminosos em operações de pavimentação de grande escala.",
        image: IMAGES.nightHighway,
    },
    {
        title: "Transporte de Inertes",
        desc: "Movimentação de todo o tipo de inertes para infraestruturas e construção.",
        image: IMAGES.dumpTruck,
    },
    {
        title: "Transporte de cargas líquidas difíceis de transportar",
        desc: "Ligação entre centrais e obras sem quebra da cadeia de fornecimento.",
        image: IMAGES.highwayTruck,
    },
    {
        title: "Abastecimento de Água",
        desc: "Cisternas dedicadas ao abastecimento de obras e operações industriais.",
        descBold: "Abastecimento de populações com água potável, assegurando o transporte e fornecimento de água a localidades, reservatórios e comunidades sempre que necessário.",
        image: IMAGES.semiDriving,
    },
    {
        title: "Projetos Industriais",
        desc: "Apoio logístico a projetos industriais com exigências rigorosas.",
        image: IMAGES.refinery,
    },
];

export const ADVANTAGES = [
    {
        title: "Experiência",
        desc: "Mais de duas décadas de atividade no setor.",
    },
    {
        title: "Capacidade",
        desc: "Frota diversificada e capacidade para operações de grande dimensão.",
    },
    {
        title: "Flexibilidade",
        desc: "Soluções adaptadas às necessidades de cada cliente.",
    },
    {
        title: "Fiabilidade",
        desc: "Compromisso com prazos, segurança e qualidade do serviço.",
    },
    {
        title: "Proximidade",
        desc: "Empresa familiar com acompanhamento próximo de cada cliente.",
    },
];

export const SERVICE_TYPES = [
    "Transporte de Inertes",
    "Transporte de Betuminosos",
    "Transporte de Água",
    "Transporte de Equipamentos",
    "Transporte de Mercadorias",
    "Transporte Internacional",
    "Outro",
];

export const IMAGE_SLOTS = [
    { key: "hero", group: "Geral", label: "Hero — página inicial", fallback: IMAGES.hero },
    { key: "cta", group: "Geral", label: "Fundo da secção final (CTA)", fallback: IMAGES.nightHighway },
    { key: "about-team", group: "Geral", label: "Quem Somos — fotografia grande", fallback: IMAGES.team },
    { key: "about-workshop", group: "Geral", label: "Quem Somos — fotografia vertical", fallback: IMAGES.workshop },
    { key: "home-fleet-1", group: "Geral", label: "Secção Frota (home) — foto 1", fallback: IMAGES.scania },
    { key: "home-fleet-2", group: "Geral", label: "Secção Frota (home) — foto 2", fallback: IMAGES.volvo },
    { key: "home-fleet-3", group: "Geral", label: "Secção Frota (home) — foto 3", fallback: IMAGES.dumpTruck },
    { key: "home-fleet-4", group: "Geral", label: "Secção Frota (home) — foto 4", fallback: IMAGES.semiDriving },
    ...SERVICES.map((s) => ({ key: `service-${s.id}`, group: "Serviços", label: s.title, fallback: s.image })),
    ...FLEET.map((v, i) => ({ key: `fleet-${i + 1}`, group: "Frota", label: v.name, fallback: v.image })),
    ...PROJECT_AREAS.map((p, i) => ({ key: `project-${i + 1}`, group: "Projetos", label: p.title, fallback: p.image })),
    { key: "empresa-hero", group: "Páginas", label: "Empresa — hero", fallback: IMAGES.duskTruck },
    { key: "empresa-1", group: "Páginas", label: "Empresa — capítulo 1", fallback: IMAGES.team },
    { key: "empresa-2", group: "Páginas", label: "Empresa — capítulo 2", fallback: IMAGES.scania },
    { key: "empresa-3", group: "Páginas", label: "Empresa — capítulo 3", fallback: IMAGES.duskTruck },
    { key: "servicos-hero", group: "Páginas", label: "Serviços — hero", fallback: IMAGES.construction },
    { key: "frota-hero", group: "Páginas", label: "Frota — hero", fallback: IMAGES.scania },
    { key: "projetos-hero", group: "Páginas", label: "Projetos — hero", fallback: IMAGES.portNight },
    { key: "contactos-hero", group: "Páginas", label: "Contactos — hero", fallback: IMAGES.aerialHighway },
];

export const TEXT_SLOTS = [
    { key: "home-hero-overline", group: "Página Inicial", label: "Hero — linha pequena superior", fallback: "Transportes Alzira — Todo o território nacional" },
    { key: "home-hero-subtitle", group: "Página Inicial", label: "Hero — subtítulo", fallback: "Experiência, capacidade e confiança no transporte rodoviário de mercadorias." },
    { key: "home-hero-complement", group: "Página Inicial", label: "Hero — texto complementar", fallback: "Desde 1998, asseguramos soluções de transporte adaptadas às exigências de cada projeto, em todo o território nacional — e internacionais quando necessário." },
    { key: "home-about-title", group: "Página Inicial", label: "Quem Somos — título", fallback: "Experiência que se transforma em |confiança." },
    { key: "home-about-p1", group: "Página Inicial", label: "Quem Somos — parágrafo 1", fallback: "Fundada em 1998, a Transportes Alzira, Lda. é uma empresa familiar especializada no transporte rodoviário de mercadorias e na prestação de serviços de transporte para obras e projetos de grande dimensão." },
    { key: "home-about-p2", group: "Página Inicial", label: "Quem Somos — parágrafo 2", fallback: "Ao longo dos anos, construímos uma estrutura sólida, assente numa frota diversificada, numa equipa experiente e num compromisso permanente com a qualidade, segurança e cumprimento dos nossos compromissos." },
    { key: "home-about-p3", group: "Página Inicial", label: "Quem Somos — parágrafo 3", fallback: "Trabalhamos diariamente para oferecer soluções de transporte eficientes, flexíveis e adaptadas às necessidades de cada cliente." },
    { key: "home-services-title", group: "Página Inicial", label: "Serviços — título", fallback: "Soluções de transporte |à medida." },
    { key: "home-fleet-title", group: "Página Inicial", label: "Frota — título", fallback: "Uma frota preparada para |qualquer desafio." },
    { key: "home-fleet-text", group: "Página Inicial", label: "Frota — texto", fallback: "Dispomos de uma frota diversificada de veículos pesados e equipamentos especializados, permitindo-nos responder a diferentes necessidades operacionais." },
    { key: "home-projects-title", group: "Página Inicial", label: "Projetos — título", fallback: "Experiência em operações de |grande dimensão." },
    { key: "home-projects-subtitle", group: "Página Inicial", label: "Projetos — subtítulo", fallback: "Colaboramos em projetos que exigem capacidade operacional, rigor e uma resposta logística eficiente." },
    { key: "home-experience-title", group: "Página Inicial", label: "A Nossa Experiência — título", fallback: "A nossa |experiência." },
    { key: "home-experience-text", group: "Página Inicial", label: "A Nossa Experiência — texto", fallback: "Ao longo dos anos, participámos em alguns dos mais relevantes projetos de infraestruturas em Portugal, contribuindo com a nossa experiência, capacidade operacional e uma frota preparada para responder aos desafios de cada obra." },
    { key: "home-map-title", group: "Página Inicial", label: "Mapa — título", fallback: "Operamos onde o seu projeto |precisa de nós." },
    { key: "home-map-text", group: "Página Inicial", label: "Mapa — texto", fallback: "Fortemente implantados em Portugal, asseguramos serviços de transporte em todo o território nacional e realizamos operações internacionais, incluindo Espanha, sempre que o projeto o exige." },
    { key: "home-why-title", group: "Página Inicial", label: "Porquê Alzira — título", fallback: "Cinco razões. Um |compromisso." },
    { key: "home-cta-title", group: "Página Inicial", label: "CTA final — título", fallback: "Tem um projeto para |transportar?" },
    { key: "home-cta-subtitle", group: "Página Inicial", label: "CTA final — subtítulo", fallback: "Fale connosco e encontre a solução certa para a sua operação." },
    ...SERVICES.map((s) => ({ key: `service-short-${s.id}`, group: "Serviços — resumos", label: s.title, fallback: s.short })),
    ...SERVICES.map((s) => ({ key: `service-long-${s.id}`, group: "Serviços — descrições", label: s.title, fallback: s.long })),
    { key: "service-extra-agua", group: "Serviços — descrições", label: "Transporte de Água — linha extra", fallback: SERVICES.find((s) => s.id === "agua").extra },
    ...ADVANTAGES.map((a, i) => ({ key: `advantage-${i}`, group: "Vantagens (Porquê Alzira)", label: a.title, fallback: a.desc })),
    { key: "empresa-hero-sub", group: "Páginas — subtítulos", label: "Empresa — hero", fallback: "Empresa familiar fundada em 1998, especializada em transporte rodoviário de mercadorias e soluções de transporte pesado." },
    { key: "servicos-hero-sub", group: "Páginas — subtítulos", label: "Serviços — hero", fallback: "Do transporte de inertes ao transporte internacional — capacidade, flexibilidade e rigor em cada operação." },
    { key: "frota-hero-sub", group: "Páginas — subtítulos", label: "Frota — hero", fallback: "Mais de 60 camiões e 80 reboques, além de equipamentos especializados, prontos para responder a diferentes necessidades operacionais." },
    { key: "projetos-hero-sub", group: "Páginas — subtítulos", label: "Projetos — hero", fallback: "Colaboramos em projetos que exigem capacidade operacional, rigor e uma resposta logística eficiente." },
    { key: "contactos-hero-sub", group: "Páginas — subtítulos", label: "Contactos — hero", fallback: "Fale connosco e encontre a solução certa para a sua operação. Resposta rápida, sem compromisso." },
];

export const ADP_TOWNS = [
    "Odemira",
    "Nisa",
    "Pedrógão Grande",
    "Oleiros",
    "Coimbra",
    "Borba",
    "Gouveia",
    "Mação",
    "Fundão",
    "Covilhã",
];


export const EXPERIENCE_GROUPS = [
    {
        id: "rodovias",
        label: "Autoestradas & Vias Rodoviárias",
        items: [
            "A25 — Vilar Formoso",
            "A42 — Fafe – Paços de Ferreira",
            "IP2 — Trancoso – Vila Nova de Foz Côa",
            "A17 — Monte Redondo",
            "IP8 — Grândola",
            "IP8 — Sines",
            "CRIL / A8 — Loures – Lisboa",
            "A5 — Oeiras – Monsanto",
            "A1 — Torres Novas – Santarém",
            "IP2 / A6 — Évora",
            "IP3 — Tondela – Viseu",
            "N125 — Albufeira – Olhão",
            "IC27 — Castro Marim",
            "A23 — Mação – Castelo Branco",
            "IC16 — Cascais",
            "A9 — Túnel de Montemor e Caneças",
        ],
    },
    {
        id: "ferrovia-tuneis",
        label: "Ferrovia & Túneis",
        items: [
            "Túnel do Marão",
            "Linha de Évora – Elvas – Alandroal",
            "Linha Évora – Alandroal – Redondo",
            "Túneis de drenagem — Lisboa",
        ],
    },
    {
        id: "grandes-projetos",
        label: "Grandes Projetos",
        items: [
            "Hospital da Luz — Lisboa",
            "CBF — Fundão",
            "Auchan — Cascais",
            "IKEA — Frielas – Loures",
        ],
    },
];
